import { PlateInfoDTO } from 'business/models/Models';
import PlateService from 'business/services/PlateService';
import RMCustomButton from 'components/customComponents/CommonComponents/RMCustomButton/RMCustomButton';
import { useModalHandlers } from 'components/modal';
import React from 'react';
import EditBarcodeModalBody from './EditBarcodeModalBody';
import EditBarcodeResponseModalBody from '../EditBarcodeResponseModalBody';

interface Props {
  plate: PlateInfoDTO;
  disabled: boolean;
  onEditPlateBarcode: (plateId: number, barcode: string) => void;
  setSelectedPlateList: React.Dispatch<React.SetStateAction<PlateInfoDTO[]>>;
}

const plateService = new PlateService();

const EditBarcode = (props: Props) => {
  const { plate, disabled, setSelectedPlateList, onEditPlateBarcode } = props;
  const { showModal, hideModal, showLoadingModal } = useModalHandlers();

  const onConfirmEditBarcode = async (barcode: string) => {
    hideModal();
    showLoadingModal('Please wait');
    const response = await plateService.EditPlateBarcode(plate.id, barcode);
    if (response) {
      hideModal();
      setSelectedPlateList((prev) =>
        prev.map((_plate) =>
          _plate.id === plate.id ? ({ ..._plate, barcode } as PlateInfoDTO) : _plate,
        ),
      );
      onEditPlateBarcode(plate.id, barcode);
    } else {
      showModal({
        id: `index-editbarcode-modal-error-${plate.id}`,
        body: <EditBarcodeResponseModalBody />,
        heading: 'Error Barcode',
        okButtonText: 'Try Again',
        onOk: showEditBarcodeModal,
      });
    }
  };

  const showEditBarcodeModal = async () => {
    if (!plate) {
      return;
    }

    showLoadingModal('Please wait');

    let currentBarcode = plate.barcode;
    try {
      const plateInfo = await plateService.getPlateInfo(false, plate.id);
      if (plateInfo?.barcode != null) {
        currentBarcode = plateInfo.barcode;
      }
    } catch (error) {
      console.error('Failed to load current plate barcode:', error);
    }

    hideModal();

    const plateWithCurrentBarcode = {
      ...plate,
      barcode: currentBarcode,
    } as PlateInfoDTO;

    showModal({
      id: `index-editbarcode-modal-edit-${plate.id}`,
      body: (
        <EditBarcodeModalBody
          plate={plateWithCurrentBarcode}
          hideModal={hideModal}
          updateBarcode={(barcode) => {
            onConfirmEditBarcode(barcode);
          }}
        />
      ),
      showFooterSeparator: false,
      heading: 'Edit Barcode',
      isCancelOnly: true,
      noButtonText: 'Cancel',
      onOk: hideModal,
      showButtons: false,
    });
  };

  return (
    <RMCustomButton
      title="EDIT BARCODE"
      mainContainerClass={`${
        disabled ? 'bg-[#cacaca]' : 'bg-[#313131]'
      } px-2 py-1 rounded-md`}
      titleClass={`${disabled ? 'text-[#9b9b9b]' : 'text-white'} font-semibold`}
      isDisabled={disabled}
      onClick={showEditBarcodeModal}
    />
  );
};

export default EditBarcode;
